/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getMandatoryDeductionByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetMandatoryDeductionById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getMandatoryDeductionByIdIdRegExpTwo)]).optional()
});

export type GetMandatoryDeductionById = zod.input<typeof GetMandatoryDeductionById>;
export type GetMandatoryDeductionByIdOutput = zod.output<typeof GetMandatoryDeductionById>;
